import React from 'react';
import { observer } from 'mobx-react';
import { ImportReferenceTypeListTemplate } from 'themes/application/import-reference-type/pages';
import { setCurrentView } from 'core/utils';
import { ImportReferenceTypeViewStore } from 'application/import-reference-type/stores';

@setCurrentView((rootStore) => new ImportReferenceTypeViewStore(rootStore), 'listViewStore')
@observer
class ImportReferenceTypeList extends React.Component {
    render() {
        return <ImportReferenceTypeListTemplate {...this.props} />
    }
}

export default ImportReferenceTypeList;